module.exports = __webpack_public_path__ + "img/hud_main_circle.5a18fb02.png";